import { render, staticRenderFns } from "./WindRose.vue?vue&type=template&id=4aaad8d3&scoped=true&"
import script from "./WindRose.vue?vue&type=script&lang=js&"
export * from "./WindRose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aaad8d3",
  null
  
)

export default component.exports